// istanbul ignore file
import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZKpiParameter = z.object({
  site_id: z.string().nullable(),
  site_name: z.string().nullable(),
  asset_id: z.string().nullable(),
  asset_name: z.string().nullable(),
  device_id: z.string().nullable(),
  device_name: z.string().nullable(),
  parameter_type: z.string().nullable(),
  parameter_id: z.string().nullable(),
  parameter_name: z.string().nullable(),
  is_device_id: z.boolean().nullable(),
  constant_value: z.number().nullable()
})

const ZStage = z.object({
  stage_id: z.string(),
  operator: z.string(),
  operator_type: z.string().optional(),
  calculated_name: z.string(),
  stage_value: z.number().nullable(),
  kpi_parameters: z.array(ZKpiParameter)
})

const ZKpiData = z.object({
  kpi_name: z.string(),
  kpi_description: z.string(),
  is_assetLevel: z.boolean(),
  higher_limit_notification: z.string(),
  lower_limit_notification: z.string(),
  unit: z.string(),
  is_enabled: z.boolean().nullable(),
  frequency: z.number(),
  device_type: z.string().nullable(),
  device_type_id: z.string().nullable(),
  device_model: z.string().nullable(),
  scale_factor: z.any(),
  totalizer_type: z.string().nullable(),
  totalize_period: z.string().nullable(),
  updated_at: z.optional(z.string().nullable()),
  dashboard_text: z.record(z.string(), z.string()).nullable().optional(),
  stage: z.array(ZStage)
})

const ZKpiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: ZKpiData
})

export type Kpi = z.infer<typeof ZKpiData>

export async function fetchKpiData (
  kpiDefinitionId: string,
  onSuccess: (kpi: Kpi, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any,
  hierarchyId?: string
): Promise<void> {
  let url = `/kpirest/api/v1/udp/tiq/kpi/getCustomKpi/${kpiDefinitionId}`
  if (hierarchyId != null && hierarchyId.trim() !== '') {
    url += `?hierarchyId=${hierarchyId}`
  }
  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response: any) => {
      const parseResponse = ZKpiResponse.safeParse(response.data)
      // istanbul ignore else
      if (parseResponse.success) {
        // istanbul ignore else
        if (
          parseResponse.data.data !== null &&
            parseResponse.data.data !== undefined
        ) {
          onSuccess(parseResponse.data.data, response.status)
        } else {
          onFailure(parseResponse.data.error, response.status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error: any) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
